import useResponsive from "./useResponsive";

export function useIsMobile() {
   return useResponsive("down", "sm");
}

export function useIsTablet() {
   return useResponsive("between", null, "sm", "md");
}

export function useIsDesktop() {
   return useResponsive("up", "md");
}

export function useIsTV() {
   return useResponsive("up", "xl");
}
